import { render, staticRenderFns } from "./ListSettings.vue?vue&type=template&id=6fb39b62&"
import script from "./ListSettings.vue?vue&type=script&lang=js&"
export * from "./ListSettings.vue?vue&type=script&lang=js&"
import style0 from "./ListSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports